import { Link } from 'react-router-dom';
import type { Episode } from '@/mocks/episodes';

interface EpisodeCardProps {
  episode: Episode;
  compact?: boolean;
}

export default function EpisodeCard({ episode, compact = false }: EpisodeCardProps) {
  const updated = episode.status === '已更新';

  return (
    <Link
      to={`/detail/${episode.id}`}
      className="group flex flex-col overflow-hidden rounded-lg bg-background-900 border border-primary-900/40 hover:border-primary-500/60 transition-all duration-300 cursor-pointer h-full"
    >
      <div className={`relative w-full ${compact ? 'h-32' : 'h-44'} overflow-hidden`}>
        <img
          src={episode.cover}
          alt={`${episode.title} 剧集封面`}
          title={`${episode.title} 无颜之月动漫`}
          className="w-full h-full object-top object-cover transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-background-950/90 via-background-950/10 to-transparent"></div>
        <span className="absolute top-3 left-3 rounded-md bg-background-950/80 backdrop-blur px-2 py-1 text-xs font-heading font-semibold text-accent-400">
          EP {String(episode.number).padStart(2, '0')}
        </span>
        <span
          className={`absolute top-3 right-3 rounded-md px-2 py-1 text-xs font-medium backdrop-blur ${
            updated
              ? 'bg-secondary-500/85 text-background-50'
              : 'bg-background-950/80 text-foreground-300 border border-foreground-700/50'
          }`}
        >
          {episode.status}
        </span>
        <span className="absolute bottom-3 right-3 flex items-center gap-1 text-xs text-foreground-200">
          <i className="ri-time-line"></i>
          {episode.duration}
        </span>
      </div>

      <div className={`flex flex-col flex-1 ${compact ? 'p-3' : 'p-4'}`}>
        <h3 className="font-heading font-semibold text-foreground-50 group-hover:text-accent-400 transition-colors line-clamp-1">
          {episode.title}
        </h3>
        <p className="mt-1 text-xs text-foreground-500 tracking-wide line-clamp-1">{episode.subtitle}</p>
        <p className="mt-2 text-sm text-foreground-400 leading-relaxed line-clamp-2 flex-1">{episode.summary}</p>
        <div className="mt-3 flex flex-wrap gap-2">
          {episode.tags.slice(0, 3).map((tag) => (
            <span
              key={tag}
              className="rounded-full bg-secondary-500/15 border border-secondary-500/25 px-2 py-0.5 text-[11px] text-secondary-200"
            >
              {tag}
            </span>
          ))}
        </div>
      </div>
    </Link>
  );
}